import { IconChevronLeft, IconChevronRight, IconDots } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { SearchPaginationInfo } from "@shared/graphql";
import { PaginationPayload } from "../../models/search";
import { DataProps } from "../../tools/components";
import "./pagination.scss";

type Props = DataProps<SearchPaginationInfo> & {
  onPaginate: (value: PaginationPayload) => void
}

const SearchedPagination = ({ className, data, onPaginate }: Props) => {

  const wrapperClasses = classNames("pagination-wrapper", className);

  if (data.pageCount < 2)
    return;

  return (
    <div className={wrapperClasses}>
      <ul>

        {data.pageCount > 1 &&
          <li>
            <button type="button"
                    onClick={() => onPaginate({
                      direction: data.currentPage != 2 ?"before" : "after",
                      ...(data.currentPage != 2) && { cursor: data.previousPageCursor }
                    })}
                    disabled={!data.hasPreviousPage}>
              <IconChevronLeft />
            </button>
          </li>
        }

        <li>
          <button type="button"
                  className={classNames({ current: data.currentPage === 1 })}
                  onClick={() => onPaginate({ direction: "after" })}
                  disabled={data.currentPage === 1}>1</button>
        </li>

        {(data.pageCount > 3 && data.currentPage > 3) &&
          <li>
            <button type="button" className="dots" disabled={true}>
              <IconDots />
            </button>
          </li>
        }

        {!!data.linkPageCursors && data.linkPageCursors.map((link, index) => (
          <li key={index}>
            <button type="button"
                    className={classNames({ current: data.currentPage === link.page })}
                    onClick={() => onPaginate({ direction: "after", cursor: link.cursor})}>{link.page}</button>
          </li>))
        }

        {(data.pageCount > 3 && data.currentPage < data.pageCount - 4) &&
          <li>
            <button type="button" className="dots" disabled={true}>...</button>
          </li>
        }

        {data.pageCount > 1 &&
          <li>
            <button type="button"
                    className={classNames({ current: data.currentPage === data.pageCount })}
                    onClick={() => onPaginate({ direction: "after", cursor: data.lastPageCursor })}
                    disabled={data.currentPage === data.pageSize}>{data.pageCount}</button>
          </li>
        }
        {data.pageCount > 1 &&
          <li>
            <button type="button"
                    onClick={() => onPaginate({ direction: "after", cursor: data.nextPageCursor })}
                    disabled={!data.hasNextPage}>
              <IconChevronRight />
            </button>
          </li>
        }

      </ul>
    </div>);

}

export default SearchedPagination;
